import { Space, Button as AntButton } from "antd";
import { useListBlogCategories } from "api/blog/queries";
import { Button } from "components/Button";
import { FC, PropsWithChildren } from "react";

interface Props {
  value: string;
  onChange: (value: string | "") => void;
}

interface TabButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const TabButton: FC<TabButtonProps> = ({ isActive, children, onClick }) => {
  if (isActive) {
    return (
      <Button
        type="text"
        onClick={onClick}
        style={{ fontFamily: "inherit", letterSpacing: "normal" }}
      >
        {children}
      </Button>
    );
  }
  return (
    <AntButton
      onClick={onClick}
      type="text"
      style={{
        color: "#111111",
      }}
    >
      {children}
    </AntButton>
  );
};

const CategoryTabs: FC<Props> = ({ value, onChange }) => {
  const { data: categories } = useListBlogCategories();

  return (
    <Space
      style={{
        padding: 8,
        border: "1px solid #11111114",
        boxShadow: "0px 4px 10px rgba(17, 17, 17, 0.02)",
        borderRadius: 6,
        marginTop: 75,
      }}
    >
      <TabButton
        isActive={value === ""}
        onClick={() => {
          onChange("");
        }}
      >
        View all
      </TabButton>
      {Array.isArray(categories) &&
        categories.map((category) => (
          <TabButton
            key={category._id}
            isActive={value === category._id}
            onClick={() => {
              onChange(category._id);
            }}
          >
            {category.name}
          </TabButton>
        ))}
    </Space>
  );
};

export default CategoryTabs;
